// Generated by portal/sdk/scripts/build.js.
module.exports = "/login-wall/milla-login-wall.77989e45fa18.js";
